// extracted by mini-css-extract-plugin
module.exports = {"inputWrapper":"StoreAvailabilitySearchInput_inputWrapper__5OmIr","inputField":"StoreAvailabilitySearchInput_inputField__UVJ6O","close":"StoreAvailabilitySearchInput_close__1z4p_"};